import { useId } from "react";
import type { Convenio } from "@/api/contrato";
import { banco } from "@/formato";
import { Dica } from "@/componentes/Dica";

/*
 * A escolha dos convênios que um vínculo permite.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ "TODOS" É UMA ESCOLHA EXPLÍCITA, E NÃO A LISTA VAZIA.                    │
 * │                                                                          │
 * │ Na API, `null` é todos os convênios do beneficiário e `[]` é nenhum      │
 * │ (pendência P16). Uma tela que mandasse `null` quando nada está marcado   │
 * │ alargaria o vínculo justamente quando o operador desmarcou tudo para     │
 * │ fechá-lo. Por isso são dois rádios: "Todos" manda `null`; "Só os         │
 * │ marcados" manda a lista — vazia, se for o caso, e aí é "nenhum".         │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
export function EscolhaDeConvenios({
  convenios,
  valor,
  aoMudar,
}: {
  /** Os convênios DO beneficiário: a API recusa os de outro. */
  convenios: readonly Convenio[];
  valor: string[] | null;
  aoMudar: (valor: string[] | null) => void;
}) {
  const nome = useId();
  const todos = valor === null;

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="flex items-center gap-1">
        <span className="rotulo">Convênios</span>
        <Dica texto="Com outro integrador no mesmo cedente, a API exige a lista: cada um emite só pelos seus convênios." />
      </legend>

      <label className="flex items-center gap-2 text-corpo text-texto">
        <input type="radio" name={nome} checked={todos} onChange={() => aoMudar(null)} />
        Todos
      </label>
      <label className="flex items-center gap-2 text-corpo text-texto">
        <input type="radio" name={nome} checked={!todos} onChange={() => aoMudar(valor ?? [])} />
        Só os marcados
      </label>

      {!todos && (
        <div className="ml-6 flex flex-col gap-1">
          {convenios.length === 0 ? (
            <p className="text-[12px] text-texto-2">Nenhum convênio.</p>
          ) : (
            convenios.map((convenio) => (
              <label key={convenio.id} className="flex items-center gap-2 text-corpo text-texto">
                <input
                  type="checkbox"
                  checked={valor.includes(convenio.id)}
                  onChange={(evento) =>
                    aoMudar(
                      evento.target.checked
                        ? [...valor, convenio.id]
                        : valor.filter((id) => id !== convenio.id),
                    )
                  }
                />
                <span className="dados">
                  {banco(convenio.banco)} · {convenio.numero}
                </span>
              </label>
            ))
          )}
        </div>
      )}
    </fieldset>
  );
}
